import PropTypes from "prop-types";
//Styles
import styles from "./PricingContent.module.scss";

const PricingContent = ({ data }) => {
  return (
    <div className={styles.root}>
      <h1 className={styles.title}>{data?.name}</h1>
      <p className={styles.pricesDiscount}>
        {data?.discount}% OFF INITIAL SERVICE VISIT
      </p>
      <div className={styles.pricesContainer}>
        <p className={styles.regularPrice}>${data?.regularPrice.toFixed(0)}</p>
        <p className={styles.discountedPrice}>
          ${data?.discountPrice.toFixed(0)}
        </p>
      </div>
      <p className={styles.pricesDescription}>
        <b>Then ${data?.subscriptionPrice.toFixed(0)}/month for 12 months</b>{" "}
        for bi-monthly maintenance
      </p>
    </div>
  );
};

PricingContent.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    discount: PropTypes.number.isRequired,
    regularPrice: PropTypes.number.isRequired,
    discountPrice: PropTypes.number.isRequired,
    subscriptionPrice: PropTypes.number.isRequired,
  }),
};

export default PricingContent;
